export const getUserPhoneNumber = currentUser => {
  return currentUser?.attributes?.profile?.protectedData?.phoneNumber;
};

export const hidePhoneVerification = currentUser => {
  return currentUser?.attributes?.profile?.protectedData?.hidePhoneVerificationModal;
};

export const isPhoneNumberVerified = currentUser => {
  return currentUser?.attributes?.profile?.protectedData?.isPhoneNumberVerified;
};

export function getListingCategoryLevel(listing = {}) {
  const { id = {}, attributes = {} } = listing;
  if (!id.uuid) {
    return null;
  }

  const category = attributes.publicData?.categoryLevel1;
  return category ?? null;
}

export const getListingType = listing => {
  const { id = {}, attributes = {} } = listing;
  if (!id.uuid) {
    return null;
  }

  const listingType = attributes.publicData?.listingType;
  return listingType ?? null;
};
export const getCategoryLabel = (categoryId, categories = []) =>
  categories.find(cat => cat.id === categoryId)?.name ?? null;

export const getListingServiceArea = (listing, isServiceListingCard) => {
  if (!listing?.id?.uuid) return null;

  const serviceArea = listing?.attributes?.publicData?.serviceArea ?? null;

  if (!isServiceListingCard && typeof serviceArea === 'string') {
    // Remove any "+ XX miles" part (e.g., "+ 25 miles", "+25mi", etc.)
    return serviceArea.replace(/\+\s?\d+\s?(miles|mi)/i, '').trim();
  }

  return serviceArea;
};
